module.exports = __webpack_public_path__ + "static/img/1.6b545a7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/1.jpeg
// module id = 98FJ
// module chunks = 45